import type { ReactNode } from 'react'
import type { ApiError } from '../api/client'

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="state">
      <div className="spin" />
      <p>{label}</p>
    </div>
  )
}

export function EmptyState({
  icon = '·',
  title,
  body,
  action,
}: {
  icon?: string
  title: string
  body?: string
  action?: ReactNode
}) {
  return (
    <div className="state">
      <div className="ei">{icon}</div>
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action}
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: ApiError; onRetry?: () => void }) {
  return (
    <div className="state">
      <div className="ei">!</div>
      <h3>{error.isForbidden ? 'You do not have access to this' : 'Something went wrong'}</h3>
      <p>
        {error.message}
        {error.code ? ` (${error.code})` : ''}
      </p>
      {onRetry ? (
        <button className="btn" type="button" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  )
}
